import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { groupBy } from 'lodash'
import moment from 'moment';

interface WarehousesResortListState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    days: any[];
    schema: any;

    meta: any;
}

const state: WarehousesResortListState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    days: [],
    schema: null,

    meta: {},
};

export const ITEMS_LIST = 'GET_WAREHOUSE_RESORT_LIST';

export const actions: ActionTree<WarehousesResortListState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "manager_name": "e.name",
                "product_name": "p.name",
                "product_container_name": "pc.name",
                "product_container_weight": "pc.weight",
                "created_at": "mv.created_at",
                "quantity": "mv.quantity",
                "reasone": "mv.reasone",
            };

            const filter: any[] = [];


            if (query.since) {
                filter.push({"$gte": ["mv.created_at", {"$": moment(query.since).format('YYYY-MM-DD 00:00:00')}]})
            }
            if (query.until) {
                filter.push({"$lte": ["mv.created_at", {"$": moment(query.until).format('YYYY-MM-DD 00:00:00')}] })
            }

            if (query.warehouse_id) {
                filter.push({ "$eq": ["mv.warehouse_id", {"$": query.warehouse_id}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:warehouses_resort",
                    "from_as": "mv",
                    "joins": [
                      {
                        "join": "s:products",
                        "type": "left",
                        "as":   "p",
                        "on": {
                          "$eq": ["mv.product_id", "p.id"]
                        }
                      },
                      {
                        "join": "s:product_containers",
                        "type": "left",
                        "as":   "pc",
                        "on": {
                          "$eq": ["mv.product_container_id", "pc.id"]
                        }
                      },
                      {
                        "join": "s:employees",
                        "type": "left",
                        "as":   "e",
                        "on": {
                          "$eq": ["mv.manager_id", "e.id"]
                        }
                      }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'asc' ? { $asc: [columns[query.sortField || 'quantity' ]] } : { $desc: [columns[query.sortField || 'quantity']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve(null);
            }));
        })
    },

};

export const mutations: MutationTree<WarehousesResortListState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents

        state.schema = data.schema;
        state.meta = fetchEnumsFromSchema(data.schema);
        console.log(state.meta)

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_warehouses_resort_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
